import { render } from "./SearchBox.vue?vue&type=template&id=1f005d1f&scoped=true&ts=true"
import script from "./SearchBox.vue?vue&type=script&lang=ts"
export * from "./SearchBox.vue?vue&type=script&lang=ts"

import "./SearchBox.vue?vue&type=style&index=0&id=1f005d1f&scoped=true&lang=scss"

import exportComponent from "/home/yjmthu/github/vua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f005d1f"]])

export default __exports__